import React, { Component } from "react";
import { Button, SelectBox } from "devextreme-react";
import { SelectBoxOnValueChangedEvent } from "../../types/DevExtremeTypes";

interface RightToWorkChecksSidePanelProps {
    onApplyButtonClick: (rightToWorkCheckStatusId: string) => void;
}

interface RightToWorkChecksSidePanelState {
    disableApplyButton: boolean;
    statusTypeList: Array<{ id: string; value: string }>;
    rightToWorkCheckStatusId: string;
}

class RightToWorkChecksSidePanel extends Component<RightToWorkChecksSidePanelProps> {
    state: RightToWorkChecksSidePanelState;

    constructor(props: RightToWorkChecksSidePanelProps) {
        super(props);
        this.state = {
            disableApplyButton: false,
            statusTypeList: [
                { id: "", value: "All" },
                { id: "1", value: "Not Required" },
                { id: "5", value: "Pending" },
                { id: "20", value: "Passed" },
                { id: "30", value: "Expired" },
                { id: "40", value: "Suspended" },
                { id: "99", value: "Failed" }
            ],
            rightToWorkCheckStatusId: ""
        };
    }

     
    /**
     * Updates selected Right To Work checks status filter.
     */
    handleChangeStatusTypeChange = (dxValueChange: SelectBoxOnValueChangedEvent) => {
        this.setState({
            rightToWorkCheckStatusId: dxValueChange.value
        });
    };

     
    /**
     * Pushes selected status filter to the parent page.
     */
    onApplyButtonClicked = () => {
        this.props.onApplyButtonClick(this.state.rightToWorkCheckStatusId);
    };

    render() {
        return (
            <div>
                <div className="row mt-4">
                    <div className="col-10">
                        <h4 className="sidebar__heading font-weight-bold">Filter</h4>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col sidebar__heading">Right To Work Check Status</div>
                </div>
                <div className="row mt-2">
                    <div className="col">
                        <SelectBox
                            dataSource={this.state.statusTypeList}
                            displayExpr="value"
                            valueExpr="id"
                            onValueChanged={this.handleChangeStatusTypeChange}
                            value={this.state.rightToWorkCheckStatusId}
                        />
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-6 mx-auto">
                        <Button
                            className="btn btn-primary btn--large"
                            disabled={this.state.disableApplyButton}
                            onClick={this.onApplyButtonClicked}
                        >
                            Apply
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default RightToWorkChecksSidePanel;
